import type React from 'react';
import { useTranslation } from 'react-i18next';

import { Error as BaseErrorComponent } from '@/js/libs/error-boundary';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import { DEFAULT_ERROR } from 'src/constants';

interface ErrorComponentProps {
  title: React.ReactNode;
  pending?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reFetch?: (...args: any[]) => any;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({ title = DEFAULT_ERROR, reFetch, pending = false }) => {
  const [t] = useTranslation(['backend', 'common', 'components']);

  const handleRetryClick = useCallbackRef(() => reFetch?.());

  return <BaseErrorComponent title={title} onRetryClick={handleRetryClick} pending={pending} retryLabel={t('components:RETRY')} />;
};

export default ErrorComponent;
